import React from 'react';
import { TOP_BAR_ITEMS } from '@/lib/storage';
import { Package, Wrench, MoreHorizontal } from 'lucide-react';

const getIcon = (iconName: string) => {
  switch (iconName) {
    case 'Package':
      return <Package className="h-4 w-4" />;
    case 'Wrench':
      return <Wrench className="h-4 w-4" />;
    case 'MoreHorizontal':
      return <MoreHorizontal className="h-4 w-4" />;
    default:
      return <Package className="h-4 w-4" />;
  }
};

export const TopBar: React.FC = () => {
  return (
    <div className="bg-dark-card/50 border-b border-dark-border py-3 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm font-medium">
          {TOP_BAR_ITEMS.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2 text-neutral-300 hover:text-gold transition-colors cursor-pointer group"
            >
              <span className="text-gold/80 group-hover:text-gold transition-colors">
                {getIcon(item.icon)}
              </span>
              <span className="hidden sm:inline">{item.label}</span>
              <span className="sm:hidden">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};